import type { SchemaStation } from '../schema/types'

/** What the index reads of a stop. */
export type ComplexStation = Pick<SchemaStation, 'id' | 'slug' | 'naptanId'>

/**
 * Stop id → the NaPTANs of every station in its complex: the stations that
 * share its `slug` (TASK-986). v2 gives each mode at one place its own NaPTAN
 * — Heathrow T5 is `910GHTRWTM5` on the Elizabeth line and `940GZZLUHR5` on
 * the Piccadilly — and the rider who asked for the Piccadilly stop has
 * arrived on reaching either. A stop without a slug is its own complex.
 * iOS / Android twin: `StationComplexIndex`.
 */
export function buildStationComplexIndex(schema: {
  readonly stations: readonly ComplexStation[]
}): (stopId: string) => ReadonlySet<string> {
  const naptansBySlug = new Map<string, Set<string>>()
  for (const stop of schema.stations) {
    if (stop.slug === undefined || stop.naptanId === undefined || stop.naptanId === '') continue
    const naptans = naptansBySlug.get(stop.slug) ?? new Set<string>()
    naptans.add(stop.naptanId)
    naptansBySlug.set(stop.slug, naptans)
  }
  const naptansByStop = new Map<string, ReadonlySet<string>>()
  for (const stop of schema.stations) {
    const complex = stop.slug === undefined ? undefined : naptansBySlug.get(stop.slug)
    if (complex !== undefined) naptansByStop.set(stop.id, complex)
    else if (stop.naptanId !== undefined && stop.naptanId !== '')
      naptansByStop.set(stop.id, new Set([stop.naptanId]))
  }
  const none: ReadonlySet<string> = new Set()
  return (stopId) => naptansByStop.get(stopId) ?? none
}
